  //USP-163 | Add Homepage Shopping Categories

function loadCss() {
  document.querySelector("head").insertAdjacentHTML(
    "beforeend",
    `<style>
.usp163-container {
  display: grid;
  grid-template-columns: 40% 40%;
  justify-content: center;
  gap: 12px;
}

.usp163-link {
  background-color: #a41d35;
  color: white;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  border-radius: 10px;
}

.usp163-title {
  font-weight: bold;
  display: flex;
  justify-content: center;
  margin: 15px 0 15px 0;
}

.usp163-link:hover {
  color: #ffffff;
  opacity: 0.8;
}
@media screen and (min-width: 1000px) {
    .usp163-container,.usp163-title {
        display: none;
}

}

		</style>`
  );
}

(function () {
  function init() {
    loadCss();
    document.querySelector(".main-content > div:nth-child(3)").insertAdjacentHTML(
      "afterend",

      `
      <div class="usp163-title">SHOP NEW ARRIVALS</div>
      <div class="usp163-container">
        <a class="usp163-link" href="https://uspoloassn.com/collections/women-new-arrivals">Women</a>
        <a class="usp163-link" href="https://uspoloassn.com/collections/mens-new-arrivals">Men</a>
        <a class="usp163-link" href="https://uspoloassn.com/collections/all-accessories">Accessories</a>
        <a class="usp163-link" href="https://uspoloassn.com/collections/boys-new-arrivals">Boys</a>

      </div>`
    );
  }


  function poll(sel, cb) {
    setTimeout(function () {
      if (document.querySelector(sel)) cb();
      else poll(sel, cb);
    }, 50);
  }
  poll(".main-content > div:nth-child(2)", init);
})();
